import React, { createContext, ReactElement, useState } from 'react';
import { ApprovalConfig } from 'src/hooks/useApprovalDecision';
import { PromoteConfig } from 'src/hooks/useManualDeployment';
import { RedeployConfig } from 'src/hooks/useModelRedeployment';
import { OperatorActionConfig } from 'src/hooks/useTriggerOperatorAction';
import { OperatorHelpConfig } from 'src/components/OperatorHelpModal';
import { OperatorOverrideConfig } from 'src/components/OverrideModal';

interface OperatorModalContext {
  approvalConfig: ApprovalConfig | null;
  operatorHelpConfig: OperatorHelpConfig | null;
  overrideConfig: OperatorOverrideConfig | null;
  promoteConfig: PromoteConfig | null;
  redeployConfig: RedeployConfig | null;
  retryConfig: OperatorActionConfig | null;
  setApprovalConfig: (approvalConfig: ApprovalConfig | null) => void;
  setOperatorHelpConfig: (
    operatorHelpConfig: OperatorHelpConfig | null,
  ) => void;
  setOverrideConfig: (arg: OperatorOverrideConfig | null) => void;
  setPromoteConfig: (promoteConfig: PromoteConfig | null) => void;
  setRedeployConfig: (redeployConfig: RedeployConfig | null) => void;
  setRetryConfig: (retryConfig: OperatorActionConfig | null) => void;
}

/* istanbul ignore next */
export const OperatorModalContext = createContext<OperatorModalContext>({
  approvalConfig: null,
  operatorHelpConfig: null,
  overrideConfig: null,
  promoteConfig: null,
  redeployConfig: null,
  retryConfig: null,
  setApprovalConfig: () => null,
  setOperatorHelpConfig: () => null,
  setOverrideConfig: () => null,
  setPromoteConfig: () => null,
  setRedeployConfig: () => null,
  setRetryConfig: () => null,
});

export const OperatorModalProvider = (props: { children: ReactElement }) => {
  const [approvalConfig, setApprovalConfig] = useState<ApprovalConfig | null>(
    null,
  );
  const [overrideConfig, setOverrideConfig] =
    useState<OperatorOverrideConfig | null>(null);

  const [promoteConfig, setPromoteConfig] = useState<PromoteConfig | null>(
    null,
  );
  const [redeployConfig, setRedeployConfig] = useState<RedeployConfig | null>(
    null,
  );
  const [retryConfig, setRetryConfig] = useState<OperatorActionConfig | null>(
    null,
  );
  const [operatorHelpConfig, setOperatorHelpConfig] =
    useState<OperatorHelpConfig | null>(null);
  return (
    <OperatorModalContext.Provider
      value={{
        approvalConfig,
        operatorHelpConfig,
        overrideConfig,
        promoteConfig,
        redeployConfig,
        retryConfig,
        setApprovalConfig,
        setOperatorHelpConfig,
        setOverrideConfig,
        setPromoteConfig,
        setRedeployConfig,
        setRetryConfig,
      }}
    >
      {props.children}
    </OperatorModalContext.Provider>
  );
};
